export default {
  zh: {
    title: '任务主题',
    hint: '请从下方所有主题中选择一个',
    placeholder: '主题名称',
    label: '添加新主题',
  },
  en: {
    title: 'Subjects',
    hint: 'Select a subject from below',
    placeholder: 'Subject name',
    label: 'Add New Subject',
  },
};



// WEBPACK FOOTER //
// ./src/components/ui/SubjectsModal/i18n.js